import { type PlacementDetailsSectionId } from "../../placementDetailsSections";

interface ScrollToSectionInContainerParams {
  scrollContainer: HTMLDivElement;
  sectionId: PlacementDetailsSectionId;
  behavior?: ScrollBehavior;
}

export function scrollToSectionInContainer(params: ScrollToSectionInContainerParams): boolean {
  const { scrollContainer, sectionId, behavior = "smooth" } = params;
  const targetElement = document.getElementById(sectionId);

  if (!targetElement) {
    return false;
  }

  const scrollTop = getElementScrollTop({
    scrollContainer,
    targetElement,
  });

  scrollContainer.scrollTo({ top: scrollTop, behavior });
  return true;
}

interface GetElementScrollTopParams {
  scrollContainer: HTMLDivElement;
  targetElement: HTMLElement;
}

function getElementScrollTop(params: GetElementScrollTopParams) {
  const { scrollContainer, targetElement } = params;
  const containerRect = scrollContainer.getBoundingClientRect();
  const targetRect = targetElement.getBoundingClientRect();

  return targetRect.top - containerRect.top + scrollContainer.scrollTop;
}
